module.exports = __webpack_public_path__ + "img/sug3.8c331878.png";